import { render } from "./daimianshi.vue?vue&type=template&id=9555bfbe&scoped=true"
import script from "./daimianshi.vue?vue&type=script&lang=js"
export * from "./daimianshi.vue?vue&type=script&lang=js"

import "./daimianshi.vue?vue&type=style&index=0&id=9555bfbe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9555bfbe"]])

export default __exports__